import { runWhenDomLoaded } from '@frontend/utils/dom';

import { Application } from '@hotwired/stimulus';
import NavbarComponentController from '@components/navbar/component_controller';
import NewsletterSignupController from './newsletter-signup_controller';
import NewsletterSignupToggleController from './newsletter-signup-toggle_controller';
import WebflowIframeController from './webflow-iframe_controller';
import SteadyCheckoutWidget from '@frontend/app/features/SteadyCheckoutWidget';
import Rails from '@rails/ujs';

const application = Application.start();
application.register('navbar--component', NavbarComponentController);
application.register('newsletter-signup', NewsletterSignupController);
application.register(
  'newsletter-signup-toggle',
  NewsletterSignupToggleController
);
application.register('webflow-iframe', WebflowIframeController);

runWhenDomLoaded(() => {
  if (window._rails_loaded !== true) {
    Rails.start(); // NB: Used e.g. for the Newsletter Embed (which uses rails ujs) to submit the form
  }

  SteadyCheckoutWidget.init(); // Only required for the /mitglied-werden page on webflow
});
